const STORAGE_KEY = 'booker_utm';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

export function captureUtmFromUrl(search = window.location.search) {
  if (typeof window === 'undefined' || !search) return null;
  const params = new URLSearchParams(search);
  const utm = {};

  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v;
  });

  const plan = params.get('plan');
  if (plan) utm.plan = plan;

  if (Object.keys(utm).length === 0) return null;

  utm.landingPath = window.location.pathname;
  utm.capturedAt = Date.now();

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
  } catch (e) {
    // localStorage may be disabled (incognito + Safari) — silently skip
  }

  return utm;
}

export function getStoredUtm() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.capturedAt || Date.now() - parsed.capturedAt > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch (e) {
    return null;
  }
}

export function clearStoredUtm() {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // ignore
  }
}

export function buildSignupHrefWithUtm(basePath, extraParams = {}) {
  const params = new URLSearchParams();
  Object.entries(extraParams).forEach(([k, v]) => {
    if (v != null) params.set(k, String(v));
  });
  const stored = getStoredUtm();
  if (stored) {
    UTM_KEYS.forEach((k) => {
      if (stored[k] && !params.has(k)) params.set(k, stored[k]);
    });
    if (stored.plan && !params.has('plan')) params.set('plan', stored.plan);
  }
  const qs = params.toString();
  return qs ? `${basePath}?${qs}` : basePath;
}
